<template>
	<v-card class="banner elevation-0" v-bind:style="{ marginTop: `${mt}px` }">
		<a
			v-if="
				banner.banner_click_url &&
				banner.banner_click_url !== 'https://clowder.com/banner-without-link'
			"
			:href="banner.banner_click_url"
			target="_blank"
		>
			<img
				:src="banner.banner_content"
				alt="banner image"
				class="banner-image"
				v-bind:style="{ borderRadius: imageBorderRadius }"
			/>
		</a>
		<img
			v-else
			:src="banner.banner_content"
			alt="banner image"
			class="banner-image"
			v-bind:style="{ borderRadius: imageBorderRadius }"
		/>
		<div class="pa-4" v-if="isTitleVisible || isDescriptionVisible">
			<v-card-title v-if="isTitleVisible" class="banner-title pa-0">
				{{ banner.banner_title }}
			</v-card-title>
			<v-card-text
				v-if="isDescriptionVisible"
				class="banner-text"
				v-bind:style="{ marginTop: !isTitleVisible ? '8px' : '0' }"
			>
				{{ banner.banner_description }}
			</v-card-text>
		</div>
	</v-card>
</template>
<script>
import { mapActions } from 'vuex'

export default {
	props: {
		banner: {
			type: Object,
			default: () => {},
		},
		mt: {
			type: Number,
			default: 0,
		},
	},
	methods: {
		...mapActions('advertisement', ['recordBannerView']),
	},
	computed: {
		isTitleVisible() {
			return this.banner.banner_type === 2 && this.banner.banner_title
		},
		isDescriptionVisible() {
			return this.banner.banner_type !== 4 && this.banner.banner_description
		},
		imageBorderRadius() {
			if (
				this.banner.banner_type === 4 ||
				(!this.isTitleVisible && !this.isDescriptionVisible)
			) {
				return '10px'
			} else {
				return '10px 10px 0 0'
			}
		},
	},
	mounted() {
		this.banner.banner_view_url && this.recordBannerView(this.banner.banner_view_url)
	},
}
</script>
<style lang="scss">
.banner {
	line-height: 0;
	border-radius: 10px !important;
	font-family: Montserrat, sans-serif;

	&-image {
		width: 100%;
	}

	&-title {
		font-size: 18px;
		font-weight: 700;
		line-height: 21.94px;
		color: var(--accent-color);
	}

	&-text {
		font-size: 14px;
		line-height: 17.07px;
		color: var(--accent-color);
	}
}
</style>
